import React from 'react'

const NotFound = () => <p>Brak route'a</p>

export default NotFound
